import { createPortal } from "react-dom";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GlobalToaster = () => {
	return createPortal(
		<ToastContainer
			position="top-right"
			autoClose={5000}
			hideProgressBar={false}
			newestOnTop={false}
			rtl={false}
			pauseOnFocusLoss
			draggable
			pauseOnHover
			theme="colored"
			transition={Zoom}
		/>,
		document.body
	);
};

export default GlobalToaster;
